import apiCall from '../utils/api-call/apiCall';
import { createHeaders } from './constants';

const getAllApisWithSubscription = async () => {
  try {
    const headers = createHeaders();
    return await apiCall('all-apis-with-subscription', 'GET', {}, headers);
  } catch (error) {
    throw error;
  }
};

export { getAllApisWithSubscription };